import { GET, URLS, POST, PUT, PATCH, SET_VALUE, DELETE } from '../../utils'
import { types as LoadingTypes } from './loading'
import { types as ToastTypes } from './toast'
import ROUTER from '@/router.js'

/**
 * Company 公司的状态管理
 */

export const types = {
  /**
   * 公司首页数据请求
   */
  FETCH_LIST_COMPANY_DATA: 'COMPANY/FETCH_LIST_COMPANY_DATA',
  /**
   * 公司等级列表请求
   */
  FETCH_LIST_COMPANY_TYPE: 'COMPANY/FETCH_LIST_COMPANY_TYPE',
  /**
   * 我的公司请求
   */
  FETCH_MY_COMPANY: 'COMPANY/FETCH_MY_COMPANY',
  /**
   * 新建公司请求
   */
  FETCH_CREATE_COMPANY: 'COMPANY/FETCH_CREATE_COMPANY',
  /**
   * 公司详情请求
   */
  FETCH_DETAIL_COMPANY: 'COMPANY/FETCH_DETAIL_COMPANY',
  /**
   * 公司修改请求
   */
  FETCH_UPDATE_COMPANY: 'COMAPNY/FETCH_UPDATE_COMPANY',
  /**
   * 加入公司请求
   */
  FETCH_JOIN_COMPANY: 'COMPANY/FETCH_JOIN_COMPANY',
  /**
   * 离开公司请求
   */
  FETCH_QUIT_COMPANY: 'COMPANY/FETCH_QUIT_COMPANY',
  /**
   * 解散公司请求
   */
  FETCH_DELETE_COMPANY: 'COMPANY/FETCH_DELETE_COMPANY',
  /**
   * 公司产品列表请求
   */
  FETCH_PRODUCT_LIST: 'COMPANY/FETCH_PRODUCT_LIST',
  /**
   * 公司内部员工产品列表请求
   */
  FETCH_PRODUCT_LIST_INSIDE: 'COMPANY/FETCH_PRODUCT_LIST_INSIDE',
  /**
   * 公司成员列表请求
   */
  FETCH_MEMBER_LIST: 'COMPANY/FETCH_MEMBER_LIST',
  /** 
  *  更改公司成员职位 
  */
  FETCH_UPDATE_JOB: 'COMPANY/FECTH_UPDATE_JOB',
  /**
   * 公司产品订单生成请求
   */
  FETCH_CREATE_PRODUCT_ORDER: 'COMPANY/FETCH_CREATE_PRODUCT_ORDER',
  /**
   * 公司收入排行榜列表请求
   */
  FETCH_RANK_LIST: 'COMPANY/FETCH_RANK_LIST',
  /**
   * 公司产品新建请求
   */
  FETCH_PRODUCT_CREATE: 'COMPANY/FETCH_PRODUCT_CREATE',
  /**
   * 给员工发工资请求
   */
  FETCH_PAY_MEMBER: 'COMAPNY/FETCH_PAY_MEMBER',
  /**
   * 我购买的作品请求
   */
  FETCH_MY_BUY_WORKS: 'COMPANY/FETCH_MY_BUY_WORKS',
  /**
   * 下架产品 
   */
  FETCH_REMOVE_PRODUCT: 'COMPANY/FETCH_REMOVE_PRODUCT',

  /**
   * 公司成员列表数据处理
   */
  GETTER_MEMBER_LIST: 'COMPANY/GETTER_MEMBER_LIST'

}

const state = {
  // 公司列表
  company_list: {
    page: 1,
    page_size: 10,
    load_more: false,
    data: [],
    total_count: 0
  },
  //某个等级下公司列表
  company_type: {
    page: 1,
    page_size: 10,
    load_more: false,
    data: [],
    total_count: 0
  },
  // 当前公司
  currentCompany: null,
  // 我的公司(当前登陆者)
  myCompany: null,
  // 公司成员列表
  member: {
    page: 1,
    page_size: 10,
    load_more: false,
    data: [],
    total_count: 0
  },
  // 公司产品列表
  product: {
    page: 1,
    page_size: 10,
    load_more: false,
    data: [],
    total_count: 0
  },
  // 内部人员看到的公司产品
  product_inside: {
    page: 1,
    page_size: 10,
    load_more: false,
    data: [],
    total_count: 0
  },
  // 已买公司产品列表
  buy_work: {
    page: 1,
    page_size: 10,
    load_more: false,
    data: [],
    total_count: 0
  },
  // 公司收入排行榜
  rank_data: []
}

const mutations = {
  set_load_more(state, param) {
    // param: {"value": true, "data_type":"member"}
    if (param.data_type === types.FETCH_LIST_COMPANY_TYPE) {
      state.company_type.load_more = param.value
    } else if (param.data_type === types.FETCH_MEMBER_LIST) {
      state.member.load_more = param.value
    } else if (param.data_type === types.FETCH_PRODUCT_LIST) {
      state.product.load_more = param.value
    } else if (param.data_type === types.FETCH_MY_BUY_WORKS) {
      state.buy_work.load_more = param.value
    } else if (param.data_type === types.FETCH_PRODUCT_LIST_INSIDE) {
      state.product_inside.load_more = param.value
    }
  },
  set_pagenum(state, param) {
    // param: {"value": 3, "data_type":"member"}
    if (param.data_type === types.FETCH_LIST_COMPANY_TYPE) {
      state.company_type.page = param.value
    } else if (param.data_type === types.FETCH_MEMBER_LIST) {
      state.member.page = param.value
    } else if (param.data_type === types.FETCH_PRODUCT_LIST) {
      state.product.page = param.value
    } else if (param.data_type === types.FETCH_MY_BUY_WORKS) {
      state.buy_work.page = param.value
    } else if (param.data_type === types.FETCH_PRODUCT_LIST_INSIDE) {
      state.product_inside.page = param.value
    }
  },
  set_list_data(state, param) {
    // param: {"data": [], "data_type":"member"}
    // console.log("param",param)
    if (param.data_type === types.FETCH_LIST_COMPANY_DATA) {
      if (state.company_list.page === 1) {
        state.company_list.data = param.data
      } else {
        state.company_list.data = state.company_list.data.concat(param.data)
      }
      state.company_list.total_count = param.count
    } else if (param.data_type === types.FETCH_LIST_COMPANY_TYPE) {
      if (state.company_type.page === 1) {
        state.company_type.data = param.data
      } else {
        state.company_type.data = state.company_type.data.concat(param.data)
      }
      state.company_type.total_count = param.count
    } else if (param.data_type === types.FETCH_MEMBER_LIST) {
      if (state.member.page === 1) {
        state.member.data = param.data
        // 将 CEO 员工放到首位(放到 getter 里处理)
        // let ceo_item = state.member.data.find(item=> item.position === 'ceo')
        // if(ceo_item){
        //     state.member.data = [ceo_item].concat(state.member.data.filter(item=>item.position !== 'ceo'))
        // }
      } else {
        state.member.data = state.member.data.concat(param.data)
      }
      state.member.total_count = param.count
    } else if (param.data_type === types.FETCH_PRODUCT_LIST) {
      if (state.product.page === 1) {
        state.product.data = param.data
      } else {
        state.product.data = state.product.data.concat(param.data)
      }
      state.product.total_count = param.count
    } else if (param.data_type === types.FETCH_MY_BUY_WORKS) {
      if (state.buy_work.page === 1) {
        state.buy_work.data = param.data
      } else {
        state.buy_work.data = state.buy_work.data.concat(param.data)
      }
      state.buy_work.total_count = param.count
    } else if (param.data_type === types.FETCH_UPDATE_JOB) {   //更改公司职员职位
      state.member.data = state.member.data.filter((item) => {
        return item.pk !== param.data.pk
      })
      state.member.data.push(param.data)
    } else if (param.data_type === types.FETCH_PRODUCT_LIST_INSIDE) {
      if (state.product_inside.page === 1) {
        state.product_inside.data = param.data
      } else {
        state.product_inside.data = state.product_inside.data.concat(param.data)
      }
    }
  },
  update_list_data(state, param) {
    if (param.data_type === types.FETCH_LIST_COMPANY_DATA) {
      state.company_list.data.unshift(param.data)
    } else if (param.data_type === types.FETCH_LIST_COMPANY_TYPE) {
      state.company_type.data.unshift(param.data)
    } else if (param.data_type === types.FETCH_MEMBER_LIST) {
      state.member.data.unshift(param.data)
      // state.member.data.splice(1, 0, param.data)
      state.currentCompany.is_member = true
    } else if (param.data_type === types.FETCH_PRODUCT_LIST) {
      state.product.data.unshift(param.data)
    }
  },
  delete_list_data(state, param) {
    if (param.data_type === types.FETCH_LIST_COMPANY_DATA) {
      state.company_list.data = state.company_list.data.filter(item => {
        return item.pk !== param.data.pk
      })
    } else if (param.data_type === types.FETCH_LIST_COMPANY_TYPE) {
      state.company_type.data = state.company_type.data.filter(item => {
        return item.pk !== param.data.pk
      })
    } else if(param.data_type === types.FETCH_LIST_COMPANY_TYPE){
      state.company_type.data = state.company_type.data.filter(item => {
        return item.pk !== param.data.pk
      })
    }else if (param.data_type === types.FETCH_MEMBER_LIST) {
      state.member.data = state.member.data.filter(item => {
        return item.pk !== param.data.pk
      })
      state.currentCompany.is_member = false
    } else if (param.data_type === types.FETCH_PRODUCT_LIST) {
      state.product.data = state.product.data.filter(item => {
        return item.pk !== param.data.pk
      })
    }
  },
  set_current_company(state, param) {
    state.currentCompany = param
  },
  update_current_company_income(state, param) {
    if (state.currentCompany && state.currentCompany.pk === param.company_id) {
      state.currentCompany.exist_income -= param.diamond
    }
  },
  update_product_buy(state, param) {
    var arr = []
    state.product.data.map(item => {
      let new_item = { ...item }
      if (new_item.showwork.pk === param.showwork.pk) {
        new_item['is_buy'] = true
      }
      arr.push(new_item)
    })
    // console.log(arr);
    state.product.data = arr

    // 同时更新一下当前公司的资产
    if (state.currentCompany && state.currentCompany.pk === param.company) {
      state.currentCompany.total_income += param.amount
      state.currentCompany.exist_income += param.amount
    }
  },
  set_rank_data(state, param) {
    state.rank_data = param
  },
  set_my_company(state, param) {
    state.myCompany = param
  }
}
const actions = {
  /**
     * 公司某个等级列表
     * @param {*} param {"page":1}
     */
  [types.FETCH_LIST_COMPANY_TYPE]({ commit, state }, param) {
    // param: {"page":1}
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types.FETCH_LIST_COMPANY_TYPE }
    commit('set_load_more', { ...temp_dic, 'value': false })
    commit('set_pagenum', { ...temp_dic, 'value': param.page })

    GET(URLS.list_grade_data).then(response => {
      // 跟新数据源
      // console.log(response,"response")
      commit('set_list_data', { 
        ...temp_dic, 
        'data': response.results, 
        'count': response.count 
      })

      // 移除等待动画
      commit(LoadingTypes.HIDE)

    })
  },

  [types.FETCH_LIST_COMPANY_DATA]({ commit, state }, param) {
    // param: {"page":1}
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types.FETCH_LIST_COMPANY_DATA }

    GET(URLS.list_company_data).then(response => {
      // console.log(response,"response")
      // 跟新数据源
      commit('set_list_data', { ...temp_dic, 'data': response.results, 'count': response.count })

      // 移除等待动画
      commit(LoadingTypes.HIDE)

    })
  },



  /**
   * 公司等级列表(某等级下)
   */
  [types.FETCH_LIST_COMPANY_TYPE]({ commit, state }, param) {
    //打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = {
      data_type: types.FETCH_LIST_COMPANY_TYPE
    }
    commit('set_load_more', {...temp_dic,value:false})
    commit('set_pagenum',{...temp_dic,value:param.page})

    GET(URLS.list_company_type(param.page,param.grade_id)).then(response=>{
      //更新load_more
      console.log(response)
      if(response.next){
        commit('set_load_more',{...temp_dic,value:true})
      }else{
        commit('set_load_more',{...temp_dic,value:false})
      }

      //更新数据
      commit('set_list_data',{
        ...temp_dic,
        "data":response.results,
        "count":response.count
      })

      //移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },


  /**
     * 新建公司
     * @param {*} param {"name":"", "content":"", "logo":""}
     */
  [types.FETCH_CREATE_COMPANY]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types.FETCH_LIST_COMPANY }
    POST(URLS.create_company, param).then(response => {
      // 更新数据源
      commit('update_list_data', { ...temp_dic, 'data': response })
      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
     * 公司详情
     * @param {*} param {"pk":1}
     */
  [types.FETCH_DETAIL_COMPANY]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)

    let pk = param.pk
    GET(URLS.detail_company(pk)).then(response => {
      // 更新数据源
      commit('set_current_company', response)
      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
     * 我的公司
     * @param {*} param {"pk":1}
     */
  [types.FETCH_MY_COMPANY]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)

    GET(URLS.my_company).then(response => {
      // 更新数据源
      commit('set_my_company', response)
      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
     * 公司修改
     * @param {*} param {"pk":1, "name":"", "content":"", "logo":""}
     */
  [types.FETCH_UPDATE_COMPANY]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)

    let pk = param.pk
    delete param.pk
    PATCH(URLS.update_company(pk), param).then(response => {
      // 更新数据源
      commit('set_current_company', response)
      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
     * 加入公司
     * @param {*} param {"pk":1}
     */
  [types.FETCH_JOIN_COMPANY]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types.FETCH_MEMBER_LIST }

    let pk = param.pk
    PUT(URLS.join_company, { 'company_id': pk }).then(response => {
      // 更新数据源
      commit('update_list_data', { ...temp_dic, 'data': response })
      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
     * 离开公司
     * @param {*} param {"pk":1}
     */
  [types.FETCH_QUIT_COMPANY]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types.FETCH_MEMBER_LIST }

    let pk = param.pk
    PUT(URLS.quit_company, { 'company_id': pk }).then(response => {
      // 更新数据源
      commit('delete_list_data', { ...temp_dic, 'data': response })
      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
     * 公司成员列表
     * @param {*} param {"page":1, "company":1}
     */
  [types.FETCH_MEMBER_LIST]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types.FETCH_MEMBER_LIST }
    commit('set_load_more', { ...temp_dic, 'value': false })
    commit('set_pagenum', { ...temp_dic, 'value': param.page })

    GET(URLS.list_member_company(state.member.page, param.company)).then(response => {
      // 更新 load_more
      if (response.next) {
        commit('set_load_more', { ...temp_dic, 'value': true })
      } else {
        commit('set_load_more', { ...temp_dic, 'value': false })
      }

      // 跟新数据源
      commit('set_list_data', { ...temp_dic, 'data': response.results, 'count': response.count })

      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },


  /**
   *  更改公司员工职位
  */
  [types.FETCH_UPDATE_JOB]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    // console.log("param",param)
    PUT(URLS.update_member_job(param.pk), { 'free_job': param.free_job }).then(response => {
      // console.log("response",response)

      let temp_dic = { 'data_type': types.FETCH_UPDATE_JOB }
      // 更新数据源
      commit('set_list_data', { ...temp_dic, 'data': response })

      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },


  /**
     * 公司产品列表
     * @param {*} param {"page":1, "company":1}
     */
  [types.FETCH_PRODUCT_LIST]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types.FETCH_PRODUCT_LIST }
    commit('set_load_more', { ...temp_dic, 'value': false })
    commit('set_pagenum', { ...temp_dic, 'value': param.page })

    GET(URLS.list_product_company(state.product.page, param.company)).then(response => {
      // 更新 load_more
      if (response.next) {
        commit('set_load_more', { ...temp_dic, 'value': true })
      } else {
        commit('set_load_more', { ...temp_dic, 'value': false })
      }

      // 跟新数据源
      commit('set_list_data', { ...temp_dic, 'data': response.results, 'count': response.count })

      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },


  /**
   * 公司内部员工产品列表
   */
  [types.FETCH_PRODUCT_LIST_INSIDE]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types.FETCH_PRODUCT_LIST_INSIDE }
    commit('set_load_more', { ...temp_dic, 'value': false })
    commit('set_pagenum', { ...temp_dic, 'value': param.page })

    GET(URLS.list_product_company_inside(state.product_inside.page)).then(response => {
      // 更新 load_more
      if (response.next) {
        commit('set_load_more', { ...temp_dic, 'value': true })
      } else {
        commit('set_load_more', { ...temp_dic, 'value': false })
      }

      // 跟新数据源
      commit('set_list_data', { ...temp_dic, 'data': response.results, 'count': response.count })

      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },



  /**
     * 新建公司产品订单
     */
  [types.FETCH_CREATE_PRODUCT_ORDER]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)

    let pk = param.pk
    POST(URLS.create_product_company_order, { 'product_id': pk }).then(response => {
      // 更新产品购买状态
      commit('update_product_buy', response)

      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
     * 公司收入排行榜列表
     * @param {*} param {"tag":"week"} "month"、"month"
     */
  [types.FETCH_RANK_LIST]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)

    let tag = param.tag
    PUT(URLS.list_rank_company, { 'tag': tag }).then(response => {
      // 更新数据源
      commit('set_rank_data', response)

      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
     * 将作品发布到公司产品中
     * @param {*} param {"showwork_id":1}
     */
  [types.FETCH_PRODUCT_CREATE]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)

    let showwork_id = param.showwork_id
    POST(URLS.create_product_company, { 'showwork_id': showwork_id }).then(response => {
      // toast 提示
      commit(ToastTypes.SHOW, { message: '发布成功' })
      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
     * ceo 给员工发工资
     * @param {*} param {"diamond":200, "company_id":1, "member_id":1}
     */
  [types.FETCH_PAY_MEMBER]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)

    PUT(URLS.pay_member, param).then(response => {
      // 更新当前公司现有资产数据
      commit('update_current_company_income', param)

      // toast 提示
      commit(ToastTypes.SHOW, { message: '成功发放' })
      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
     * 我购买的作品列表
     * @param {*} param {"page":1, "user_id":367}
     */
  [types.FETCH_MY_BUY_WORKS]({ commit, state }, param) {
    // param: {"page":1}
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types.FETCH_MY_BUY_WORKS }
    commit('set_load_more', { ...temp_dic, 'value': false })
    commit('set_pagenum', { ...temp_dic, 'value': param.page })

    let user_id = param.user_id ? param.user_id : null
    let url = URLS.my_buy_works(state.buy_work.page, user_id)
    GET(url).then(response => {
      // 更新 load_more
      if (response.next) {
        commit('set_load_more', { ...temp_dic, 'value': true })
      } else {
        commit('set_load_more', { ...temp_dic, 'value': false })
      }

      // 跟新数据源
      commit('set_list_data', { ...temp_dic, 'data': response.results, 'count': response.count })

      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
     * 下架产品
     * @param {*} param {"pk":1}
     */
  [types.FETCH_REMOVE_PRODUCT]({ commit, state }, param) {
    // param: {"page":1}
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types.FETCH_PRODUCT_LIST }

    let pk = param.pk
    PUT(URLS.remove_company_product, { 'product_id': pk }).then(response => {
      // 更新数据源
      commit('delete_list_data', { ...temp_dic, 'data': response })
      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
   * 解散公司
   * @param {*} param {"pk":1}
   */
  [types.FETCH_DELETE_COMPANY]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)

    let pk = param.pk
    DELETE(URLS.delete_company(pk)).then(response => {
      // 移除等待动画
      commit(LoadingTypes.HIDE)
      if (window.history.length > 1) {
        ROUTER.go(-1);
      } else if (window.history.length === 1) {
        ROUTER.replace(`/?tag=company`)
      }
    })
  },

}
const getters = {
  [types.GETTER_MEMBER_LIST](state, getters, rootState, rootGetter) {
    let new_data = []
    state.member.data.map((item) => {
      let new_item = { ...item }
      new_data.push(new_item)
    })
    new_data = new_data.sort(createCompareFunction('position'))
    return new_data
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}

// 排序自定义方法
const createCompareFunction = (propertyName) => {
  return function (object1, object2) {
    var value1 = object1[propertyName]
    var value2 = object2[propertyName]
    if (value1 === 'ceo') {
      return -1
    } else {
      return 1
    }
  }
}
